<ami-dialog-message [setting]="message"></ami-dialog-message>

<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  modal="modal"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  header="Emitir Nota de Crédito"
  [style]="{ width: '30%' }"
  (onHide)="onClose()"
>
  <div class="grid">
    <div class="col-12">
      <form [formGroup]="fg">
        <div class="p-fluid p-formgrid grid">
          <div class="field col-12">
            <p-message
              severity="info"
              text="Por favor escoja el punto de venta para realizar la operación."
              styleClass="p-mr-2"
            ></p-message>
          </div>
          <div class="field col-12 md:col-10">
            <label>Punto de Venta</label>
            <input
              formControlName="pointOfSale"
              pInputText
              type="text"
              class="inputfield w-full"
              readonly
            />
          </div>
          <div class="field col-12 md:col-2">
            <button
              pButton
              pRipple
              icon="pi pi-check-square"
              class="mt-4 p-button-rounded p-button-info"
              (click)="select.pointOfSale.openDialog = true"
              pTooltip="Seleccionar Punto de Venta"
              tooltipPosition="left"
            ></button>
          </div>
          <div class="field col-12 md:col-6"></div>
          <div class="field col-12 md:col-3">
            <button
              pButton
              pRipple
              (click)="onClose()"
              icon="pi pi-times"
              class="p-button-text"
              label="No"
              pTooltip="Cancelar"
            ></button>
          </div>

          <div class="field col-12 md:col-3">
            <button
              pButton
              pRipple
              class="p-button-text"
              icon="pi pi-check"
              [disabled]="fg.invalid"
              label="Si"
              pTooltip="Anular Nota de Venta"
              (click)="onSubmit()"
            ></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</p-dialog>

<pg-point-of-sale-active-select
  *ngIf="select.pointOfSale.openDialog"
  (selectedRowsEvent)="onSelectedPointOfSale($event)"
></pg-point-of-sale-active-select>
